import app from 'app';
import fg from '#/libs/FrameGrid';

export default class KeyboardController {
  constructor({ host, audioSync }) {
    this.$video = host.$refs.video;
    this.host = host;

    if (audioSync) {
      this.$audio = new Audio(this.$video.src);
      this.$audio.volume = this.$video.volume;
      this.onVideoVolumeChange_bind = this.onVideoVolumeChange.bind(this);
      this.$video.addEventListener(
        'volumechange',
        this.onVideoVolumeChange_bind
      );
    }

    this.onAddFragment_debounced = _.debounce(
      this.onAddFragment,
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    );
  }

  register() {
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.FRAGMENT_EDITOR, [
      {
        on: 'keydown',
        key: 219 /* '[' */,
        run: this.seekFrames.bind(this),
        stash: { left: true },
      },
      {
        on: 'keydown',
        key: 221 /* ']' */,
        run: this.seekFrames.bind(this),
        stash: { right: true },
      },
      {
        on: 'keydown',
        key: $.ui.keyCode.LEFT,
        shiftKey: true,
        run: this.seekScenes.bind(this),
        stash: { left: true },
      },
      {
        on: 'keydown',
        key: $.ui.keyCode.RIGHT,
        shiftKey: true,
        run: this.seekScenes.bind(this),
        stash: { right: true },
      },
      {
        on: 'keydown',
        key: 65 /* 'A' */,
        run: this.onAddFragment_debounced.bind(this),
      },
    ]);
  }

  unregister() {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.FRAGMENT_EDITOR);

    if (this.$audio) {
      this.$video.removeEventListener(
        'volumechange',
        this.onVideoVolumeChange_bind
      );
      this.$audio.src = '';
      this.$audio = null;
    }
  }

  seekFrames(e, { left, right }) {
    const curTime = fg.round(this.$video.currentTime);
    const curFrame = fg.index(curTime);
    const nextFrame = Math.max(1, left ? curFrame - 1 : curFrame + 1);
    const nextTime = fg.time(nextFrame);

    this.$video.currentTime = nextTime;

    const doAudioSync = this.$video.paused && this.$audio;
    if (doAudioSync) {
      this.doAudioSync(nextTime);
    }
  }

  seekScenes(e, { left, right }) {
    if (this.host.scenes?.length) {
      const firstIndex = 0;
      const lastIndex = this.host.scenes.length - 1;
      let nextIndex = null;
      let currentIndex = -1;
      if (this.host.selectedScene) {
        currentIndex = _.findIndex(this.host.scenes, (scene) => {
          return this.host.selectedScene.guid === scene.guid;
        });
      } else {
        const scene = this.host.$_findSceneByTime(this.$video.currentTime, {
          left,
          right,
        });
        currentIndex = this.host.scenes.indexOf(scene);
      }

      nextIndex = left
        ? currentIndex > firstIndex
          ? currentIndex - 1
          : lastIndex
        : currentIndex < lastIndex
        ? currentIndex + 1
        : firstIndex;

      if (nextIndex !== null) {
        this.host.selectScene(this.host.scenes[nextIndex]);
      }
    }
  }

  onVideoVolumeChange() {
    this.$audio.volume = this.$video.volume;
  }

  doAudioSync(nextTime) {
    this.$audioSyncTimer = clearTimeout(this.$audioSyncTimer);
    this.$audio.currentTime = nextTime;
    this.$audio.play();
    this.$audioSyncTimer = setTimeout(() => {
      this.$audio?.pause();
    }, 250);
  }

  onAddFragment() {
    this.host.addFragment({ andClose: false });
  }
}
